export default {
  loadingWebsites: "Carga de sitios...",
  website: "Sitio web",
  websiteLoading: "Carga de organismos",
  guide: {
    show: "Ver la guía",
  },
  dataAgreement: {
    title: "Actualización de la información relacionada con el RGPD",
    save: {
      success: "¡Datos guardados con éxito!",
    },
    alert_link: "aquí.",
    alert:
      "Como parte de las obligaciones relacionadas con el cumplimiento del RGPD, es necesario que complete los campos a continuación para que los usuarios de su plataforma puedan identificarle como el responsable del tratamiento. Estos datos se utilizarán para completar la página de gestión de la política de datos de la plataforma, que puede consultar",
  },
};
